export default __webpack_public_path__ + "static/media/art-blk-poster-3.07f1e1c0.jpg";